const ArchiveView = Barba.BaseView.extend({
    namespace: 'archive',
    map: null,
    activeFilters: [],
    mapMarkers: [],
    infobox: null,
    prevVisibleMarkerList: [],
    mapIcon: { url: se_ajax.template_dir + '/dist/images/map-marker@2x.png', scaledSize: new google.maps.Size(12, 12), anchor: new google.maps.Point(6, 6) },
    mapIconActive: { url: se_ajax.template_dir + '/dist/images/map-marker-active@2x.png', scaledSize: new google.maps.Size(22, 22), anchor: new google.maps.Point(11, 11) },

    onEnter: function() {
        this.filterOptions = this.container.querySelectorAll('.jsArchiveFilterOption');
        this.searchForm = this.container.querySelector('.jsArchiveSearchForm');
        this.searchClearBtn = this.searchForm.querySelector('.clear');
        this.searchInput = this.searchForm.querySelector('.input');
        this.filterClearBtn = this.container.querySelector('.jsArchiveFilterClearAlll');

        new MainMenu(this.container);
        new InViewAnimation();
        new SearchModal(this.container);

        this.initViewSwitch();
        this.initFilters();
        this.setSearchClearBtnVisibility();
        this.setClearFilterBtnVisibility();
        setIframeAspectRatios(this.container);

        // Init the map
        if (seGoogleMapsReady) this.initMap();
        else window.addEventListener('se-google-maps-ready', this.initMap);

        // Init the archive filter
        new ArchiveFilter(this.container.querySelector('.jsArchiveFilters'));

        // Put the locations on the map
        this.updateMapLocations();

        // Init the search input clear button
        this.searchClearBtn.addEventListener('click', e => {
            this.searchInput.value = '';
            this.updateActiveFilters();
        });

        // Clear all filters
        this.filterClearBtn.addEventListener('click', _ => this.clearAllFilters());
    },

    clearAllFilters() {
        this.searchInput.value = '';

        for (let i = 0; i < this.filterOptions.length; i++) {
            this.filterOptions[i].checked = false;
        }

        this.updateActiveFilters();
    },

    setSearchClearBtnVisibility() {
        if (this.searchInput.value === '') this.searchClearBtn.style.opacity = 0;
        else this.searchClearBtn.style.opacity = 1;
    },

    setClearFilterBtnVisibility() {
        let isFiltered = false;

        if (this.searchInput.value !== '') {
            isFiltered = true;
        }

        for (let i = 0; i < this.filterOptions.length; i++) {
            if (this.filterOptions[i].checked) {
                isFiltered = true;
            }
        }

        if (isFiltered) this.filterClearBtn.style.opacity = 1;
        else this.filterClearBtn.style.opacity = 0;
    },

    initViewSwitch() {
        const viewSwitch = this.container.querySelector('.jsArchiveViewSwitch');

        if (viewSwitch) {
            const viewWrapper = this.container.querySelector('.jsArchiveViewWrapper');
            const btns = viewSwitch.querySelectorAll('button');
            const views = viewWrapper.querySelectorAll('.jsArchiveViewWrapper > div');

            Array.prototype.forEach.call(btns, btn => {
                btn.addEventListener('click', e => {
                    e.preventDefault();

                    const view = btn.dataset.switchView;

                    for (let i = 0; i < btns.length; i++) {
                        if (btns[i].dataset.switchView !== view) btns[i].classList.remove('active');
                        else btns[i].classList.add('active');

                        if (views[i].dataset.view !== view) views[i].classList.remove('active');
                        else views[i].classList.add('active');
                    }
                });
            });
        }
    },

    initFilters() {
        for (let i = 0; i < this.filterOptions.length; i++) {
            this.filterOptions[i].addEventListener('change', this.updateActiveFilters.bind(this));
        }

        const currentUrl = new Url();
        if (currentUrl.query['category']) this.activeFilters['category'] = [currentUrl.query['category']];

        // Init the search form
        this.searchForm.addEventListener('submit', e => {
            e.preventDefault();
            this.updateActiveFilters();
        });

        let inputChangeTimeout = null;

        this.searchForm.addEventListener('input', e => {
            if (inputChangeTimeout) {
                clearTimeout(inputChangeTimeout);
                inputChangeTimeout = null;
            }

            inputChangeTimeout = setTimeout(_ => {
                this.updateActiveFilters();
            }, 500);
        });
    },

    updateActiveFilters() {
        const viewWrapper = this.container.querySelector('.jsArchiveViewWrapper');
        const gridView = viewWrapper.querySelector('.grid');

        this.setSearchClearBtnVisibility();
        this.setClearFilterBtnVisibility();

        // Set the active filters
        this.activeFilters = {};
        for (let i = 0; i < this.filterOptions.length; i++) {
            if (this.filterOptions[i].checked) {
                if (this.activeFilters[this.filterOptions[i].name] === undefined) this.activeFilters[this.filterOptions[i].name] = [];
                this.activeFilters[this.filterOptions[i].name].push(this.filterOptions[i].value);
            }
        }

        // Set the search query
        const searchQuery = this.searchForm.querySelector('input').value;
        if (searchQuery) this.activeFilters['search-query'] = searchQuery;

        // Set the URL
        const url = new Url(archiveBaseUrl);
        const currentUrl = new Url();

        if (currentUrl.query['category']) {
            url.query['category'] = currentUrl.query['category'];
            this.activeFilters['category'] = [currentUrl.query['category']];
        }

        if (this.activeFilters['filter-2'] !== undefined) url.query['filter-2'] = this.activeFilters['filter-2'].join(',');
        else delete url.query['filter-2'];

        if (this.activeFilters['filter-3'] !== undefined) url.query['filter-3'] = this.activeFilters['filter-3'].join(',');
        else delete url.query['filter-3'];

        if (this.activeFilters['filter-4'] !== undefined) url.query['filter-4'] = this.activeFilters['filter-4'].join(',');
        else delete url.query['filter-4'];

        if (this.activeFilters['filter-5'] !== undefined) url.query['filter-5'] = this.activeFilters['filter-5'].join(',');
        else delete url.query['filter-5'];

        if (this.activeFilters['search-query'] !== undefined) url.query['search-query'] = this.activeFilters['search-query'];
        else delete url.query['search-query'];

        window.history.pushState(null, null, url.toString());

        // Update the GRID
        const xmlhttp = new XMLHttpRequest();
        const params = new FormData();

        params.append('action', 'get_project_archive_grid');
        params.append('base_url', archiveBaseUrlSearch + window.location.search);
        params.append('page_number', 1);
        params.append('posts_per_page', 9);

        if (this.activeFilters['category'] !== undefined) params.append('category', this.activeFilters['category'].join(','));
        if (this.activeFilters['filter-2'] !== undefined) params.append('filter-2', this.activeFilters['filter-2'].join(','));
        if (this.activeFilters['filter-3'] !== undefined) params.append('filter-3', this.activeFilters['filter-3'].join(','));
        if (this.activeFilters['filter-4'] !== undefined) params.append('filter-4', this.activeFilters['filter-4'].join(','));
        if (this.activeFilters['filter-5'] !== undefined) params.append('filter-5', this.activeFilters['filter-5'].join(','));
        if (this.activeFilters['search-query'] !== undefined) params.append('search-query', this.activeFilters['search-query']);

        // Animate the grid out
        TweenLite.to(viewWrapper.querySelector('.grid'), 0.5, { opacity: 0, ease: Power2.easeInOut });

        // Get the new grid
        xmlhttp.onreadystatechange = _ => {
            if (xmlhttp.readyState === XMLHttpRequest.DONE) {
                if (xmlhttp.status === 200) {
                    const response = JSON.parse(xmlhttp.responseText);

                    gridView.innerHTML = response.grid_html;
                    TweenLite.to(viewWrapper.querySelector('.grid'), 0.5, { opacity: 1, ease: Power2.easeInOut });
                }
                else {
                    alert('Oops, something went wrong..');
                }
            }
        };

        xmlhttp.open('POST', se_ajax.ajaxurl, true);
        xmlhttp.send(params);

        // Update the map
        this.updateMapLocations();
    },

    initMap() {
        this.map = new google.maps.Map(this.container.querySelector('.jsArchiveMap'), {
            center: { lat: 52.152854, lng: 5.086075 },
            zoom: 8,
            styles: [{"featureType":"landscape","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"stylers":[{"hue":"#00aaff"},{"saturation":-100},{"gamma":2.15},{"lightness":12}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"lightness":24}]},{"featureType":"road","elementType":"geometry","stylers":[{"lightness":57}]}],
            disableDefaultUI: true,
            zoomControl: true,
            scrollWheel: false
        });

        this.map.addListener('click', this.closeInfoBox.bind(this));
        
        let timeout = null;
        this.map.addListener('bounds_changed', _ => {
            if (timeout) clearTimeout(timeout);

            timeout = setTimeout(_ => {
                this.updateSubProjectList();
            }, 1000);
        });
    },

    updateMapLocations() {
        // Get the locations
        const xmlhttp = new XMLHttpRequest();
        const params = new FormData();

        params.append('action', 'get_map_projects');

        if (this.activeFilters['category'] !== undefined) params.append('category', this.activeFilters['category'].join(','));
        if (this.activeFilters['filter-2'] !== undefined) params.append('filter-2', this.activeFilters['filter-2'].join(','));
        if (this.activeFilters['filter-3'] !== undefined) params.append('filter-3', this.activeFilters['filter-3'].join(','));
        if (this.activeFilters['filter-4'] !== undefined) params.append('filter-4', this.activeFilters['filter-4'].join(','));
        if (this.activeFilters['filter-5'] !== undefined) params.append('filter-5', this.activeFilters['filter-5'].join(','));
        if (this.activeFilters['search-query'] !== undefined) params.append('search-query', this.activeFilters['search-query']);

        xmlhttp.onreadystatechange = _ => {
            if (xmlhttp.readyState === XMLHttpRequest.DONE) {
                if (xmlhttp.status === 200) {
                    const response = JSON.parse(xmlhttp.responseText);

                    this.deleteLocationsFromMap();

                    for (let i = 0; i < response.length; i++) {
                        const location = response[i];
                        const marker = new google.maps.Marker({
                            position: { lat: location.location[0], lng: location.location[1] },
                            map: this.map,
                            icon: this.mapIcon,
                            title: location.title
                        });

                        marker.se_location_data = location;

                        this.mapMarkers.push(marker);

                        marker.addListener('click', _ => {
                            this.showInfoBox(marker);
                            marker.setIcon(this.mapIconActive);
                        });
                    }

                    this.updateSubProjectList();
                }
                else {
                    alert('Oops, something went wrong..');
                }
            }
        };

        xmlhttp.open('POST', se_ajax.ajaxurl, true);
        xmlhttp.send(params);
    },

    deleteLocationsFromMap() {
        this.closeInfoBox();

        for (let i = 0; i < this.mapMarkers.length; i++) {
            this.mapMarkers[i].setMap(null);
        }

        this.mapMarkers = [];
    },

    showInfoBox(marker) {
        this.closeInfoBox();

        const data = marker.se_location_data;

        let ibContent = '<div class="map-infobox__inner"><a href="' + data.url + '" class="map-infobox__link">' + data.title + '</a>';
            ibContent += '<div class="map-infobox__img">' +
                '<a href="https://www.google.com/maps/place/' + data.gps_location + '" target="_blank">Navigeer naar dit project</a>' +
                '<img src="' + data.thumbnail + '" alt="' + data.title + '" /></div>';
            ibContent += '<div class="map-infobox__content-wrapper">';
                ibContent += '<div class="map-infobox__title">' + data.title + '</div>';
                ibContent += '<a href="' + data.url + '" class="map-infobox__url">Bekijk project</a>';
            ibContent += '</div></div>';

        this.infobox = new InfoBox({
            content: ibContent,
            disableAutoPan: false,
            maxWidth: 0,
            zIndex: null,
            closeBoxMargin: '0px',
            closeBoxURL: '',
            infoBoxClearance: new google.maps.Size(1, 1),
            isHidden: false,
            pane: 'floatPane',
            enableEventPropagation: false
        });

        this.infobox.open(this.map, marker);
    },

    closeInfoBox() {
        if (this.infobox !== null) {
            this.infobox.close();
        }

        Array.prototype.forEach.call(this.mapMarkers, marker => {
            marker.setIcon(this.mapIcon);
        });
    },

    getVisibleMarkers() {
        return this.mapMarkers.filter(marker => {
            const bounds = this.map.getBounds();

            if (bounds) return this.map.getBounds().contains(marker.getPosition());
            return null;
        });
    },

    updateSubProjectList() {
        const visibleMarkers = this.getVisibleMarkers();

        if (! this.arraysEqual(visibleMarkers, this.prevVisibleMarkerList)) {
            this.prevVisibleMarkerList = visibleMarkers;

            const markers = visibleMarkers.slice(0, 3);
            const grid = this.container.querySelector('.jsSubProjectGrid');
    
            if (markers.length) {
                const postIds = markers.map(marker => { return marker.se_location_data.id; });
    
                // Do the request
                const xmlhttp = new XMLHttpRequest();
                const params = new FormData();
        
                params.append('action', 'get_project_archive_grid_specific');
                params.append('post_ids', postIds.join(','));
        
                xmlhttp.onreadystatechange = _ => {
                    if (xmlhttp.readyState === XMLHttpRequest.DONE) {
                        if (xmlhttp.status === 200) {
                            const response = JSON.parse(xmlhttp.responseText);
        
                            new TimelineMax()
                                .set(grid, { height: grid.offsetHeight })
                                .to(grid, 0.5, { opacity: 0, ease: Power2.easeInOut })
                                .add(_ => { grid.innerHTML = response.grid_html; })
                                .to(grid, 0.5, { opacity: 1, ease: Power2.easeInOut })
                                .set(grid, { clearProps: 'all' })
                            ;
                        }
                    }
                };
        
                xmlhttp.open('POST', se_ajax.ajaxurl, true);
                xmlhttp.send(params);
            }
        }
    },

    arraysEqual(_arr1, _arr2) {
        if (!Array.isArray(_arr1) || ! Array.isArray(_arr2) || _arr1.length !== _arr2.length) return false;
    
        var arr1 = _arr1.concat().sort();
        var arr2 = _arr2.concat().sort();
    
        for (var i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) return false;
        }
    
        return true;
    }
});

ArchiveView.init();
